import axios from '@axios';

export default {
  namespaced: true,
  state: {
    items: [],
    logs: [],
  },
  getters: {
    getItems(state) {
      return state.items;
    },
    getSelectedItems(state) {
      return state.items.map(action_plan => ({
        value: action_plan.id,
        label: action_plan.name,
      }));
    },
  },
  mutations: {
    setData(state, value) {
      state.items = value;
    },
    setLogsData(state, value) {
      state.logs = value;
    },
  },
  actions: {
    async getAll({ commit }, params) {
      const { data } = await axios.get('v1/action_plan_document', { params })

      if (!data) {
        return []
      }
      commit('setData', data.data)
      return data
    },
    async show(_, id) {
      try {
        const { data } = await axios.get(`v1/action_plan_document/${id}`);
        return data;
      } catch (error) {
        console.error("Error fetching document details:", error);
        throw error;
      }
    },
    async add(_, params) {
      try {
        const { data } = await axios.post('v1/action_plan_document', params);
        return data;
      } catch (error) {
        console.error("Error adding document:", error);
        throw error;
      }
    },
    async edit(_, { id, params }) {
      try {
        const { data } = await axios.put(`v1/action_plan_document/${id}`, params);
        return data;
      } catch (error) {
        console.error("Error editing document:", error);
        throw error;
      }
    },
    async delete(_, id) {
      try {
        const { data } = await axios.delete(`v1/action_plan_document/${id}`);
        return data;
      } catch (error) {
        console.error("Error deleting document:", error);
        throw error;
      }
    },
    clear({ commit }) {
      commit('setData', []);
    }
  },
};
